import React from "react";
import { withUser } from "@coverme/identity";
import { InputField, CTA } from "@coverme/forms";
import { connect } from "react-redux";
import "../styles/change-password.scss";
import { changePassword } from "../services/changePasswordService";
import { toast } from "react-toastify";
import { TooltipMessage, TooltipTrigger } from "@coverme/elements";
import { Icon } from "@coverme/icons";
import { Tooltip } from "../components/Tooltips/Tooltip";
import { Formik, Field } from "formik";
import * as yup from "yup";

export const ChangePasswordComponent = ({ user, history }) => {
    const initialState = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
    };
    const newPasswordschema = yup.object().shape({
        oldPassword: yup.string().required("Current Password is required"),
        newPassword: yup
            .string()
            .required("New Password is required")
            .test("password-complexity", "Password complexity not met", function(value) {
                if (value == null) {
                    return false;
                }
                const hasNumberRegex = /[0-9]/;
                const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;
                if (value.length < 8 || !hasNumberRegex.test(value) || !specialCharRegex.test(value)) {
                    return false;
                }

                return true;
            }),
        confirmPassword: yup
            .string()
            .required("Confirm Password is required")
            .oneOf([yup.ref("newPassword"), null], "Passwords don't match"),
    });
    const getValidationState = (errors, touched, submitCount, field) => {
        return errors[field.name] && (touched[field.name] || submitCount > 0) ? "invalid" : "none";
    };

    return (
        <div className="changePassword" id="changePassword-page">
            <div className="changePassword__container">
                <div className="changePassword__close" onClick={() => history.push("/")}>
                    {" "}
                    &times;
                </div>
                <div className="changePassword__tooltip">
                    <h4>Reset Password</h4>
                </div>
                <Tooltip>
                    <TooltipTrigger>
                        <Icon icon={"tooltip"} />
                    </TooltipTrigger>
                    <TooltipMessage position={"right"} width={300}>
                        <div className="changePassword__li">
                            {
                                <ul>
                                    <li>
                                        <b>Your password must:</b>
                                    </li>
                                    <li>
                                        <span className="dot" />
                                        Be at least 8 characters{" "}
                                    </li>
                                    <li>
                                        <span className="dot" />
                                        Have at least one number{" "}
                                    </li>
                                    <li>
                                        <span className="dot" />
                                        Have at least one symbol{" "}
                                    </li>
                                    <li>
                                        <span className="dot" />
                                        Have at least one upper case letter{" "}
                                    </li>
                                    <li>
                                        <span className="dot" />
                                        Have at least one lower case letter
                                    </li>
                                </ul>
                            }
                        </div>
                    </TooltipMessage>
                </Tooltip>
                <Formik
                    initialValues={initialState}
                    validationSchema={newPasswordschema}
                    validateOnChange={false}
                    onSubmit={(fields, { setFieldError, resetForm }) => {
                        const username = user.profile.name;
                        const formData = {
                            oldPassword: fields.oldPassword,
                            newPassword: fields.newPassword,
                        };
                        changePassword(username, formData)
                            .then(res => {
                                toast.success("Your password has been reset");
                                resetForm();
                                setTimeout(() => {
                                    history.push("/");
                                }, 5000);
                            })
                            .catch(err => {
                                if (!err.response) {
                                    resetForm();
                                    toast.error(
                                        "Something went wrong while trying to reset your password.Please try again"
                                    );
                                } else {
                                    err.response.data.errors[0].code === "PasswordMismatch"
                                        ? setFieldError("oldPassword", "Old Password is Incorrect")
                                        : toast.error(
                                              "Something went wrong while trying to reset your password.Please try again"
                                          );
                                }
                            });
                    }}
                >
                    {({ handleSubmit, errors, touched, submitCount, resetForm }) => (
                        <form onSubmit={handleSubmit}>
                            {
                                <>
                                    <div className="changePassword__input">
                                        <Field name="oldPassword">
                                            {({ field }) => (
                                                <InputField
                                                    {...field}
                                                    id="old-password"
                                                    disabled={false}
                                                    placeholder="Old Password"
                                                    type="password"
                                                    title="Old Password"
                                                    errorMessage={errors[field.name]}
                                                    validState={getValidationState(errors, touched, submitCount, field)}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="changePassword__input">
                                        <Field name="newPassword">
                                            {({ field }) => (
                                                <InputField
                                                    {...field}
                                                    id="new-password"
                                                    disabled={false}
                                                    placeholder="New Password"
                                                    type="password"
                                                    title="New Password"
                                                    errorMessage={errors[field.name]}
                                                    validState={getValidationState(errors, touched, submitCount, field)}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="changePassword__input">
                                        <Field name="confirmPassword">
                                            {({ field }) => (
                                                <InputField
                                                    {...field}
                                                    id="confirm-password"
                                                    disabled={false}
                                                    placeholder="Confirm Password"
                                                    type="password"
                                                    title="Confirm Password"
                                                    errorMessage={errors[field.name]}
                                                    validState={getValidationState(errors, touched, submitCount, field)}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                </>
                            }
                            <div className="form-buttons">
                                <div className="changePassword__button">
                                    <CTA
                                        disabled={false}
                                        size={"large"}
                                        ctaType={"button"}
                                        styleType={"blue"}
                                        click={handleSubmit}
                                    >
                                        Set Password
                                    </CTA>
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export const ChangePasswordComponentWithUser = withUser(ChangePasswordComponent);

export const ChangePasswordContainer = connect()(ChangePasswordComponentWithUser);
